export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^((GIR 0AA)|((((?!([QVX]))[A-Z][0-9][0-9]?)|(((?!([QVX]))[A-Z](?!([IJZ]))[A-Z][0-9][0-9]?)|(((?!([QVX]))[A-Z][0-9][A-HJKPSTUW])|((?!([QVX]))[A-Z](?!([IJZ]))[A-Z][0-9][ABEHMNPRVWXY])))) [0-9](?!([CIKMOV]))[A-Z]{2}))$/i));
    }
}
